import React, { useState } from 'react';

import { InstantSearch, Configure } from 'react-instantsearch-dom';
import { ProducerSearch } from '/components/producer-search/components';

import algoliasearch from 'algoliasearch/lite';

const ProducerSearchApp = () => {
    const {
        ALGOLIA_APPLICATION_ID,
        ALGOLIA_SEARCH_API_KEY,
        ALGOLIA_INDEX,
    } = window.env;

    const searchClient = algoliasearch(
        ALGOLIA_APPLICATION_ID,
        ALGOLIA_SEARCH_API_KEY,
    );

    const [location, setLocation] = useState(null);
    const [radius, setRadius] = useState(15000);

    window.setSearchLocation = setLocation;
    window.setSearchRadius = setRadius;

    const config = {
        hitsPerPage: 999,
    };

    if (location) {
        config.aroundLatLng = `${location.lat}, ${location.lng}`;
        config.aroundRadius = radius;
    }

    return (
        <InstantSearch indexName={ALGOLIA_INDEX} searchClient={searchClient}>
            <Configure {...config} />
            <ProducerSearch />
        </InstantSearch>
    );
};

export { ProducerSearchApp };
